import { path } from 'ramda';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getHuggg } from 'redux/modules/huggg';
import {
  getIsLoading,
  getFormData,
  getCardData,
  submitForm,
  generateOTP,
  getOtpDelay,
} from 'redux/modules/prepaidCard';
import { clearError, getError as getVoucherError } from 'redux/modules/voucher';
import { PrepaidForm } from './PrepaidForm';
import { PrepaidFormConfirmation } from './PrepaidFormConfirmation';

export const PrepaidCardRedemptionUnconnected = (props) => {
  const history = useHistory();

  const {
    onConfirm,
    otpDelay,
    formData,
    submitForm,
    generateOTP,
    voucherError,
    clearError,
    huggg,
    segment,
  } = props;

  // Names the scheme's passcode email template. Absent for schemes that have
  // none, which sends the default.
  const otpEmailTemplateName = path(
    ['configuration', 'sangriaLayout', 'prepaidCard', 'otpEmailTemplateName'],
    segment,
  );
  const declineMessage = path(
    ['configuration', 'sangriaLayout', 'prepaidCard', 'declineMessage'],
    segment,
  );
  const unknownApiErrorMessage = path(
    ['configuration', 'sangriaLayout', 'prepaidCard', 'unknownApiErrorMessage'],
    segment,
  );

  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (voucherError) {
      setShowConfirm(true);
    }
  }, [voucherError, setShowConfirm]);

  const formatFormDataWithOtp = (otp) => {
    const { dateOfBirth } = formData;
    return {
      ...formData,
      phoneNumber: '+44' + formData.phoneNumber.slice(-10), // The current regex accepts numbers beginning with +44 or 0. This just ensures the country code is prepended in every case
      dateOfBirth: [dateOfBirth.year, dateOfBirth.month, dateOfBirth.date].join(
        '-',
      ),
      otp,
    };
  };
  const submitCardClaim = (otp) => {
    const formattedData = formatFormDataWithOtp(otp.pin);
    onConfirm(formattedData);
  };

  const submitFormData = (localFormData) => {
    submitForm(localFormData);
    generateOTP(otpEmailTemplateName);
    setShowConfirm(true);
  };

  const returnToForm = () => {
    clearError();
    setShowConfirm(false);
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <>
      {!!showConfirm ? (
        <PrepaidFormConfirmation
          voucherError={voucherError}
          declineMessage={declineMessage}
          unknownApiErrorMessage={unknownApiErrorMessage}
          otpDelay={otpDelay}
          onSubmit={submitCardClaim}
          onBack={returnToForm}
          formData={formData}
          onResendOtp={() => generateOTP(otpEmailTemplateName)}
          shortcode={huggg?.shortcode}
        />
      ) : (
        <PrepaidForm
          onSubmit={submitFormData}
          onBack={goBack}
          formData={formData}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    otpDelay: getOtpDelay(state),
    voucherError: getVoucherError(state),
    formData: getFormData(state),
    cardData: getCardData(state),
    isLoading: getIsLoading(state),
    huggg: getHuggg(state),
  };
};

export const PrepaidCardRedemption = connect(mapStateToProps, {
  submitForm,
  generateOTP,
  clearError,
})(PrepaidCardRedemptionUnconnected);
